import { useContext, useEffect, useMemo, useState } from "react";
import { Redirect, useHistory, useLocation, useParams } from "react-router";
import UserContext, { User_Type } from "./UserContext";
import { Admin_Service } from "../services/admin/admin-service";
import { Superadmin_Service } from "../services/superadmin/superadmin-service";

export default function Authenticate({ children, then = () => { } }) {
    const [content, setContent] = useState(null);
    const history = useHistory();
    const { user, setUser, setOffline, } = useContext(UserContext);
    const location = useLocation();
    const params = useParams();

    const user_type = useMemo(() => location.pathname.split("/")[1], [location.pathname])


    const loginOrRedirect = async () => {

        const handler = (user_type === User_Type.Admin ? Admin_Service.is_logged : user_type === User_Type.Superadmin ? Superadmin_Service.is_logged : null)

        if (!handler) return



        const [data, error] = await handler();



        if (data?.admin) {
            setUser({ ...data.admin, user_type });

            if (location.pathname === "/") {
                history.push(`/${user_type}`);
            } else {
                setOffline(false);
                setContent(children);
            }
        } else {
            console.log({ error });
            if (error.message === "Network Error") {
                console.log("Setting offline true");
                setOffline(true);
                // setContent(children);
                history.push(`/offline`);
            } else {
                history.replace(`/${user_type || "admin"}/login`);
                setUser(null)
            }
        }
    };

    useEffect(() => {
        if (!user_type) return

        loginOrRedirect();
    }, [location.pathname]);


    if (!user_type) return <Redirect to="/admin/login" />;


    return content
}
